import { AuthUserModel } from "app/services/api/types/authorisation/models/AuthUserModel";
import { useResendUserInviteMutation } from "app/services/api/usersApi";
import { useDisplayToast } from "ui/hooks/useDisplayToast";

export function useResendUserInvite() {
  const { showNewToast } = useDisplayToast();

  const [triggerResendUserInvite, { isLoading: isResending }] =
    useResendUserInviteMutation();

  const handleResendUserInvite = async (user: AuthUserModel) => {
    try {
      await triggerResendUserInvite({ user: user.id }).unwrap();
      showNewToast({
        id: "user-resend",
        title: "User invite has been resent!",
        message: `An email has been sent to ${user.email} to set their preferred password.`,
        type: "success",
        duration: 5000,
      });
    } catch (error) {
      console.error("Error resending user invite:", error);
      showNewToast({
        id: "user-resend-error",
        title: "Something went wrong",
        message: error?.data?.message || "An unexpected error occurred.",
        type: "error",
      });
    }
  };

  return { handleResendUserInvite, isResending };
}
